// OrderBookController
app.controller('OrderBookController', ['$scope', '$routeParams', 'sessionService', 'WdHttpService',
    function($scope, $routeParams, sessionService, WdHttpService) {
        // Init 
        $scope.init = async function() {

            await $scope.fetchAdviserSiteDetails();
            $scope.noOrders = false;
            $(function() {
                $('#my-portfolio').addClass('active');
            });
            $scope.showPageLoader();
            await $scope.orderBook();
            $scope.hidePageLoader();
        };

        $scope.investingMode = sessionService.get("investingMode") ? sessionService.get("investingMode") : "REAL";
        $scope.tableRowDetail = function(item) {
            $scope.selectedStock = item;
        }

        $scope.selectedOptions = {};
        $scope.clickedOption = {
            'BUYSELL': false,
            'BUY': false,
            'SELL': false,
            'EXCHANGEALL': false,
            'NSE': false,
            'BSE': false,
            'PENDING': false,
            'REJECTED': false
        };
        $scope.filterTable = function(value, clicked, option) {
            $scope.clickedOption[option] = clicked;
            if ((option === 'BUYSELL' && $scope.clickedOption[option])) {
                $scope.clickedOption['BUY'] = false;
                $scope.clickedOption['SELL'] = false;
            }
            if ((option === 'BUY' && $scope.clickedOption[option])) {
                $scope.clickedOption['BUYSELL'] = false;
                $scope.clickedOption['SELL'] = false;
            }
            if ((option === 'SELL' && $scope.clickedOption[option])) {
                $scope.clickedOption['BUYSELL'] = false;
                $scope.clickedOption['BUY'] = false;
            }
            if ((option === 'EXCHANGEALL' && $scope.clickedOption[option])) {
                $scope.clickedOption['NSE'] = false;
                $scope.clickedOption['BSE'] = false;
            }
            if ((option === 'NSE' && $scope.clickedOption[option])) {
                $scope.clickedOption['EXCHANGEALL'] = false;
                $scope.clickedOption['BSE'] = false;
            }
            if ((option === 'BSE' && $scope.clickedOption[option])) {
                $scope.clickedOption['NSE'] = false;
                $scope.clickedOption['EXCHANGEALL'] = false;
            }
            if ((option === 'PENDING' && $scope.clickedOption[option])) {
                $scope.clickedOption['REJECTED'] = false;
            }
            if ((option === 'REJECTED' && $scope.clickedOption[option])) {
                $scope.clickedOption['PENDING'] = false;
            }

            if (((option === 'BUYSELL' || option === 'BUY' || option === 'SELL') && !$scope.clickedOption[option])) {
                Object.assign(value, { 'BUY': 0, 'SELL': 0 })
            }
            if (((option === 'EXCHANGEALL' || option === 'NSE' || option === 'BSE') && !$scope.clickedOption[option])) {
                Object.assign(value, { 'NSE': 0, 'BSE': 0 })
            }
            if (((option === 'PENDING' || option === 'REJECTED') && !$scope.clickedOption[option])) {
                Object.assign(value, { 'BROKERPLACED': 0, 'EXCHANGEPLACED': 0, 'REJECTED': 0 })
            }
            Object.assign($scope.selectedOptions, value)
            const alphabeticallyData = $scope.allTableData.filter((item) => $scope.selectedOptions[item.side] || (!$scope.selectedOptions['BUY']) && (!$scope.selectedOptions['SELL']));
            const exchangeData = alphabeticallyData.filter((item) => $scope.selectedOptions[item.exchange] || (!$scope.selectedOptions['NSE']) && (!$scope.selectedOptions['BSE']));
            const statusData = exchangeData.filter((item) => $scope.selectedOptions[item.status] || (!$scope.selectedOptions['BROKERPLACED']) && (!$scope.selectedOptions['EXCHANGEPLACED']) && (!$scope.selectedOptions['REJECTED']));
            $scope.tableData = statusData;
        }

        $scope.orderBook = async function() {

            var date = new Date();
            date.setHours(0, 0, 0, 0);
            var todaysTimestamp = date.getTime();

            var data = {
                investingMode: $scope.investingMode,
                orderTimestamp: todaysTimestamp
            };

            await WdHttpService._investor_orderbook(data)
                .then(function(response) {
                    if (response.status == 200) {
                        $scope.tableData = response.data.orderbook;
                        if (Object.keys($scope.tableData).length === 0) {
                            $scope.noOrders = true;
                            $scope.$evalAsync();
                        } else {
                            $scope.noOrders = false;
                            $scope.tableData = response.data.orderbook;
                            $scope.allTableData = $scope.tableData;
                        }
                    }
                }).catch(error => {
                    $('#somethingWrong').modal('show');
                    $scope.showErrorPopup(error);
                });
        }
    }
]);